export class ChallengeStatisticModel {
    startedChallengesCount!: number;
    succeededChallengesCount!: number;
    scoresSum!: number;
}